import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Container, Image, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";

const PointHistory = () => {
	async function getPointHistory(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point/history").then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    const location = useLocation()
	const [pointHistory,setPointHistory] = useState([])

	useEffect(() => {
		document.querySelector("title").textContent = "ポイント履歴 - アワートAI"
		getPointHistory().then(r=>{
			if(r.result){
				setPointHistory(r.data)
			}
		})
	},[location.pathname])
    const reasonList = ["基準ポイント","ボーナスポイント","AI生成機能の利用","AIへの相談","ポイント投資","ポイント贈り","投稿ボーナス","ランキング入選","配当(ポイント運用)","特典応募"]
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container>
            <h3>ポイント履歴</h3>
            <p>直近1週間分が表示されます。</p>
            <Table striped bordered hover>
                <thead>
                    <tr><th>ポイント</th><th>理由</th><th>贈り主/贈り先/その他</th><th>日時</th></tr>
                </thead>
                <tbody>
                {pointHistory && pointHistory.map((d,i) => {
                    let text = ""
                    let eventId = ""
                    let other = ""
                    if(d.target_user_name !== null){
                        text = <Link to={"/user/"+d.target_user_id}>{d.target_user_name}</Link>
                    } else if(d.stock_name !== null) {
                        text = <>
                            [{d.buy_or_sell === 1 ? "買" : "売"}]{d.stock_name}<br />
                            単価：{d.price}<br />
                            数量：{d.amount}<br />
                            価格：{d.price * d.amount}
                        </>
                    } else {
                        let split = d.other.split(":")
                        let category = split[0]
                        if(category === "odai"){
                            let tag = split[1]
                            if(tag !== undefined && tag !== ""){
                                text = "今日のお題に参加「"+tag+"」"
                            }
                        } else if(category === "event_tag"){
                            let info = split[1].split(",")
                            let tag = info[0]
                            eventId = info[1]
                            text = "イベントに参加「"+tag+"」"
                        } else if(category === "prompt"){
                            text = "プロンプトを公開"
                        }
                    }
                    other = d.other
                    let type = ""
                    if(d.reason === 1){
                        type = "="
                    } else {
                        if(d.type === 1){
                            type = "+"
                        } else if(d.type === 2){
                            type = "-"
                        }
                    }
                    if(d.reason === 10){
                        other = d.other + "口数"
                    }
                    return <tr key={i}><td>{type} {d.point.toLocaleString()}</td><td>{reasonList[d.reason-1]}</td>
                    {eventId.length > 0 ? (
                        <td><Link to={"/event/"+eventId}>{text}</Link></td>
                    ) : (<td>{text}{other}</td>)}
                    <td>{d.create_datetime}</td></tr>
                })}
                </tbody>
            </Table>
        </Container>
        <Footer />
    </div>
    )
}

export default PointHistory;
